import type {
  IntelligenceFeedEngagementParam,
  IntelligenceFeedEngagementState,
  IntelligenceFeedItem,
  IntelligenceFeedListKind,
  IntelligenceFeedListQuery,
  IntelligenceFeedListResult,
} from "./IntelligenceFeedType";

const mockItems: IntelligenceFeedItem[] = Array.from({ length: 18 }, (_, index) => ({
  id: `intel-h5-${index + 1}`,
  title:
    index % 3 === 0
      ? "重要产业政策释放积极信号，市场关注度快速升温"
      : `盘中情报更新：重点行业最新动态 ${index + 1}`,
  summary:
    "最新公开信息显示，相关领域出现新的边际变化，短期情绪与中长期基本面值得持续跟踪。",
  occurredAt: `2026-07-${String(31 - Math.floor(index / 4)).padStart(2, "0")} ${String(
    14 - (index % 6)
  ).padStart(2, "0")}:20:00`,
  importance: Math.max(3, 10 - (index % 8)),
  type: index % 11,
  stocks:
    index % 2 === 0
      ? [
          {
            code: "600519",
            name: "贵州茅台",
            lastPrice: "1420.50",
            changePct: "1.26%",
            recommendReason: "行业龙头，基本面稳定，关注事件催化后的资金承接。",
            fundamentalScore: 8.7,
            positionScore: 6.4,
          },
        ]
      : [],
  extraKind: index % 5 === 0 ? "ai_risk" : index % 2 === 0 ? "ai_stock" : "none",
  riskDetail: "事件仍处于早期阶段，后续政策执行力度和市场反馈存在不确定性。",
  likeCount: 12 + index * 3,
  collectCount: 4 + index,
  likedByMe: false,
  collectedByMe: false,
  hasTeacherComment: index % 3 !== 1,
  teacherComment: "这条信息的关键在于边际变化，建议结合量价和后续数据持续验证。",
  teacher: {
    staffId: "teacher-1",
    realName: "研究员",
    nickname: "林老师",
    avatarUrl: "",
    firstCommentAt: "2026-07-31 14:30:00",
  },
}));

export function mockIntelligenceFeedList(
  query: IntelligenceFeedListQuery,
  kind: IntelligenceFeedListKind
): IntelligenceFeedListResult {
  const keyword = query.keyword?.trim().toLowerCase();
  const filtered = mockItems.filter((item) => {
    if (kind === "liked" && !item.likedByMe) return false;
    if (kind === "collected" && !item.collectedByMe) return false;
    if (query.type != null && item.type !== query.type) return false;
    if (
      query.minImportance != null &&
      item.importance < query.minImportance
    ) {
      return false;
    }
    if (keyword && !`${item.title} ${item.summary}`.toLowerCase().includes(keyword)) {
      return false;
    }
    return true;
  });
  const start = Math.max(0, (query.pageNum - 1) * query.pageSize);
  return {
    total: filtered.length,
    list: filtered.slice(start, start + query.pageSize),
  };
}

function toggleEngagement(
  param: IntelligenceFeedEngagementParam,
  field: "likedByMe" | "collectedByMe"
): IntelligenceFeedEngagementState {
  const item = mockItems.find((row) => row.id === param.intelligenceId);
  if (item) {
    item[field] = !item[field];
  }
  return {
    liked: Boolean(item?.likedByMe),
    collected: Boolean(item?.collectedByMe),
  };
}

export function mockToggleIntelLike(
  param: IntelligenceFeedEngagementParam
): IntelligenceFeedEngagementState {
  return toggleEngagement(param, "likedByMe");
}

export function mockToggleIntelCollect(
  param: IntelligenceFeedEngagementParam
): IntelligenceFeedEngagementState {
  return toggleEngagement(param, "collectedByMe");
}
